module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_DELTA.268eeb0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_DELTA.png
// module id = 83
// module chunks = 0